/* eslint-disable import/no-unresolved */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@material-ui/lab';
import { Box, Card, Grid, Stack, Button } from '@material-ui/core';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { createNewExclusionRule, updateExclusionRule } from 'src/redux/slices/exclusionrules';
import SingleRuleForm from './SingleRuleForm';

// ----------------------------------------------------------------------

ExclusionRuleForm.propTypes = {
  editId: PropTypes.object,
  handleClose: PropTypes.func,
  parentRuleId: PropTypes.number
};

export default function ExclusionRuleForm({ editId, handleClose, parentRuleId }) {
  const [btnSelect, setBtnSelect] = useState(false);
  const dispatch = useDispatch();

  const emptyRule = [
    {
      id: 0,
      column_name: '',
      if_cell_value: '',
      value_or_text: ''
    }
  ];

  const editRules = editId?.data;

  const tempRules = editId ? editRules : emptyRule;

  const [rules, setRule] = useState(tempRules);

  const handleAddRule = () => {
    setRule([
      ...rules,
      {
        id: parseInt(1 + Math.random() * (1000 - 1), 10),
        if_cell_value: '',
        value_or_text: '',
        column_name: ''
      }
    ]);
    setBtnSelect(false);
  };

  const handleDeleteRule = (id) => {
    const updatedRules = rules.filter((rule) => rule.id !== id);
    setRule(updatedRules);
    if (rules.length < 2) setBtnSelect(true);
  };

  const NewUserSchema = Yup.object().shape({
    rules: Yup.array(
      Yup.object({
        column_name: Yup.mixed().required('*Required'),
        if_cell_value: Yup.mixed().required('*Required'),
        value_or_text: Yup.mixed().required('*Required')
      })
    )
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      parentRuleId,
      rules
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const exclusionRuleData = {
          rules: values.rules
        };
        setSubmitting(false);
        if (editId) {
          dispatch(updateExclusionRule(exclusionRuleData, editId.ruleId));
        } else {
          dispatch(createNewExclusionRule(exclusionRuleData, parentRuleId));
        }
        handleClose();
      } catch (error) {
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, handleSubmit, isSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              {rules.map((rule, index) => (
                <SingleRuleForm
                  data={rule}
                  id={index}
                  key={index}
                  handleDeleteRule={handleDeleteRule}
                  setRule={setRule}
                  rules={rules}
                  errors={errors}
                />
              ))}
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="space-between">
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
                  {!editId && (
                    <Button
                      variant="text"
                      startIcon={<AddCircleOutlineOutlined />}
                      onClick={handleAddRule}
                      sx={{ width: '10%', height: '3rem', display: 'flex', justifyContent: 'space-around' }}
                      title="Add"
                    />
                  )}
                </Stack>
              </Stack>
              <Stack spacing={3}>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton sx={{ marginRight: '1rem' }} type="button" variant="outlined" onClick={handleClose}>
                    Cancel
                  </LoadingButton>
                  <LoadingButton
                    sx={{ marginRight: '1rem' }}
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={btnSelect}
                  >
                    {!editId ? 'Save' : 'Update'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
